import {React,useEffect,useState} from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";

const NewCompanyList = () => {
  const [viewMore, setViewMore] = useState(false)
  const [newCompanyList, setNewCompanyList] = useState([])
  useEffect(() => {
    api
      .get("/services/company/public-view/?company_type=private&is_existing_company=false")
      .then((response) => {
        setNewCompanyList(response.data)
        console.log("privte compny",response.data)
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  }, []);
  return (
    <div>
      <h1 className="text-primary-red font-Acme text-xl mt-4 sm:mt-10 font-bold underline">
        New Company List
      </h1>
      <div className="">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block md:w-full w-1 sm:px-6 lg:px-8">
              {/* search */}
              <table className="min-w-full border border-collapse table-fixed">
                <thead className="font-Bree text-sm font-bold border-b bg-white">
                  <tr>
                    <th
                      scope="col"
                      className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                    >
                      SN.
                    </th>
                    <th
                      scope="col"
                      className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                    >
                      Company Name
                    </th>
                    <th
                      scope="col"
                      className="font-fold bg-primary-red px-6 py-4 text-left text-white"
                    >
                      Address
                    </th>
                    <th
                      scope="col"
                      className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                    >
                      Company Type
                    </th>
                    <th
                      scope="col"
                      className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                    >
                      Darta Date
                    </th>
                    <th
                      scope="col"
                      className="bg-primary-red px-6 py-4 text-left font-bold text-white"
                    >
                      Darta No.
                    </th>
                   
                  </tr>
                </thead>
                <tbody className="font-Acme">
                  {

                    viewMore === false ?
                    newCompanyList?.slice(0,10).map((item, index) => {
                      return (
                        <tr key={index} className="text-primary-blue font-Acme border-b bg-gray-100">
                          <td className="whitespace-nowrap px-6 py-4  font-medium">
                           {index+1}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                           {item.company_name}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                           {item.company_address}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                            {item.company_type}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                          {item.regd_date}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                            {item.regd_number}
                          </td>
                         
                        </tr>
                      )
                    })
                    :
                    newCompanyList?.map((item, index)  => {
                      return (
                        <tr key={index} className="text-primary-blue font-Acme border-b bg-gray-100">
                          <td className="whitespace-nowrap px-6 py-4  font-medium">
                           {index+1}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                           {item.company_name}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                           {item.company_address}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                            {item.company_type}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                          {item.regd_date}
                          </td>
                          <td className="whitespace-nowrap px-6 py-4 text-base font-light">
                            {item.regd_number}
                          </td>
                         
                        </tr>
                      )
                    })
                  }

                </tbody>
              </table>
              <div className="w-full">
              <button  onClick = {()=>setViewMore(true)}  className={` bg-primary-red text-white p-2 rounded-xl my-2 ${viewMore===true&&"hidden"}`} >
                View More
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewCompanyList;
